import React, { useState, useEffect } from 'react';
import { Box, useTheme, Grid, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { format } from 'date-fns';
import { useAuth } from "../../components/AuthContext"; // Importe o contexto de autenticação

const Despesas = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { userInfo } = useAuth(); // Obtenha o usuário autenticado do contexto
  const [despesas, setDespesas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDespesas = async () => {
      if (!userInfo) return; // Aguarde até que o usuário esteja definido
  
      try {
        // Busca todas as despesas sem filtro de colaboradorId
        const response = await axios.get("https://pf-auditores.ew.r.appspot.com/api/folha-despesas");
        const despesasData = response.data;
  
        // Filtra as despesas com base no colaboradorId do usuário autenticado
        let despesasFiltered = [];
        if (userInfo.tipo === 'BASICO') {
          despesasFiltered = despesasData.filter(despesa => despesa.colaboradorId === userInfo.id);
        } else {
          despesasFiltered = despesasData;
        }
  
        // Fetch cliente and colaborador for each despesa filtrada
        const despesasWithDetails = await Promise.all(despesasFiltered.map(async (despesa) => {
          try {
            const clienteResponse = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/clientes/${despesa.clienteId}`);
            const colaborador1Response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${despesa.aprovador1}`);
            const colaborador2Response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${despesa.aprovador2}`);
  
            return {
              ...despesa,
              nomeCliente: clienteResponse.data.nomeCliente,
              nomeAprovador1: colaborador1Response.data.nome,
              nomeAprovador2: colaborador2Response.data.nome,
            };
          } catch (error) {
            console.error(`Erro ao buscar detalhes para a despesa ${despesa.id}:`, error);
            return {
              ...despesa,
              nomeCliente: 'Erro ao buscar cliente',
              nomeAprovador1: 'Erro ao buscar aprovador',
              nomeAprovador2: 'Erro ao buscar aprovador',
            };
          }
        }));
  
        // Ordena as despesas por data em ordem decrescente
        despesasWithDetails.sort((a, b) => new Date(b.data) - new Date(a.data));
  
        setDespesas(despesasWithDetails);
      } catch (error) {
        console.error("Erro ao buscar despesas:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchDespesas();
  }, [userInfo]);
  

  // Função para formatar a data no formato "dd/MM/yyyy"
  const dateFormatter = (date) => {
    return format(new Date(date), 'dd/MM/yyyy');
  };

  // Função para formatar o campo "faturado"
  const faturadoFormatter = (faturado) => {
    return faturado === true || faturado === 'true' ? 'Sim' : 'Não';
  };

  // Função para obter primeiro e último nome
  const getFirstAndLastName = (fullName) => {
    const parts = fullName.split(' ');
    return `${parts[0]} ${parts[parts.length - 1]}`;
  };
  console.log(despesas)
  const columns = [
    {
      field: "data",
      headerName: "Data",
      flex: 0.6,
      valueFormatter: (params) => dateFormatter(params.value),
    },
    {
      field: "nomeCliente",
      headerName: "Cliente",
      flex: 1.2,
    },
    {
      field: "tipoDespesa",
      headerName: "Tipo Despesa",
      flex: 0.7,
    },
    {
      field: "percursoCompleto",
      headerName: "Percurso Completo",
      flex: 1,
    },
    {
      field: "valorTotal",
      headerName: "Valor Total",
      flex: 0.6,
      valueFormatter: (params) => {
        const euroFormatter = new Intl.NumberFormat("pt-PT", {
          style: "currency",
          currency: "EUR",
        });
        return euroFormatter.format(params.value);
      },
    },
    {
      field: "matricula",
      headerName: "Matricula",
      flex: 0.5,
    },
    {
      field: "ficheiro",
      headerName: "Ficheiro",
      flex: 0.5,
      renderCell: (params) => {
        const link = params.row.ficheiro; // Assumindo que o campo "ficheiro" contém o URL do link
        return (
          <a href={`${link}`} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        );
      },
    },
    {
      field: "nomeAprovador1",
      headerName: "Aprovador 1",
      flex: 0.7,
      valueFormatter: (params) => getFirstAndLastName(params.value),
    },
    {
      field: "nomeAprovador2",
      headerName: "Aprovador 2",
      flex: 0.7,
      valueFormatter: (params) => getFirstAndLastName(params.value),
    },
    {
      field: "faturado",
      headerName: "Faturado",
      flex: 0.5,
      valueFormatter: (params) => faturadoFormatter(params.value),
    },
    {
      field: "notas",
      headerName: "Notas",
      flex: 1,
    },
    {
      field: "estado",
      headerName: "Estado",
      flex: 0.5,
    },
    // Nova coluna para o botão "Ver"
    {
      field: "verDetalhes",
      headerName: "",
      flex: 0.7,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(`/despesas/editar/${params.row.id}`)}
        >
          Ver
        </Button>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="Despesas" subtitle="Lista de despesas registradas" />
      <Grid container justifyContent="space-between" marginBottom="20px">
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => navigate('/despesas/registar')}>
            Adicionar Nova Despesa
          </Button>
        </Grid>
        <Grid item>
          {/* Adicione aqui os componentes de filtro, se necessário */}
        </Grid>
      </Grid>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .colaborador-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid 
          rows={despesas} 
          columns={columns} 
          components={{ Toolbar: GridToolbar }}
          loading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default Despesas;
